// Third-party
import React, { ReactElement } from 'react';

// Components
import { DestructiveModal } from '@capintel/component-lib/destructive-modal';

// Constants and types
import ComparisonItem from '@/types/comparison-item';

// Utils
import { formatMessage, FormattedMessage, formatLocalizedString } from '../../../../utils/i18n';

type Props = {
  show: boolean;
  groupItems: ComparisonItem[];
  onConfirm: () => void;
  onCancel: () => void;
};

const getModalContent = (groupItems: ComparisonItem[]): ReactElement => (
  <div>
    <FormattedMessage id="Comparison.Groups.Modals.DeleteGroups.Body" />
    <ul>
      {groupItems.map(groupItem => (
        <li key={groupItem._id}>
          <span>{formatLocalizedString(groupItem.name)}</span>
        </li>
      ))}
    </ul>
  </div>
);

const DeleteComparisonItemGroupsModal = ({ groupItems, show, onConfirm, onCancel }: Props) => (
  <DestructiveModal
    open={show}
    onOpenChange={open => !open && onCancel()}
    title={formatMessage('Comparison.Groups.Modals.DeleteGroups.Title')}
    content={getModalContent(groupItems)}
    confirmButtonText={formatMessage('Comparison.Groups.Modals.DeleteGroups.ConfirmLabel')}
    cancelButtonText={formatMessage('Common.Cancel')}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default DeleteComparisonItemGroupsModal;
